import { AlertTriangle, XCircle } from 'lucide-react'

interface Props {
  warnings: Array<{ message: string }>
  blockers: Array<{ message: string }>
}

export function ConstraintWarnings({ warnings, blockers }: Props) {
  if (warnings.length === 0 && blockers.length === 0) return null

  return (
    <div className="space-y-2 mb-4">
      {blockers.map((b, i) => (
        <div key={i} className="flex items-start gap-2 bg-red-50 border border-red-200 rounded-lg px-3 py-2.5 text-sm text-red-700">
          <XCircle className="h-4 w-4 shrink-0 mt-0.5" />
          <span>{b.message}</span>
        </div>
      ))}
      {warnings.map((w, i) => (
        <div key={i} className="flex items-start gap-2 bg-amber-50 border border-amber-200 rounded-lg px-3 py-2.5 text-sm text-amber-800">
          <AlertTriangle className="h-4 w-4 shrink-0 mt-0.5" />
          <span>{w.message}</span>
        </div>
      ))}
    </div>
  )
}
